import api from "./api";

export interface UnifiedCourse {
  _id: string;
  title: string;
  description?: string;
  category?: string;
  level?: string;
  type: "e-learning" | "regular";
  status?: string;
  code?: string;
}

export interface CourseResponse {
  success: boolean;
  data: UnifiedCourse[];
  count: number;
}

class CourseService {
  // Get all courses (both e-learning and regular) for quiz creation
  async getAllCoursesForQuiz(): Promise<CourseResponse> {
    const response = await api.get<CourseResponse>("/elearning/all-courses");
    return response as unknown as CourseResponse;
  }
}

export const courseService = new CourseService();
export default courseService;
